import {Injectable} from '@angular/core';
import {Avis} from 'src/app/models/avis';
import {FormsEnum} from 'src/app/models/enums/forms.enum';
import {FormExtractorService} from 'src/app/modules/shared/services/form-extractor.service';
import {LogService} from 'src/app/modules/shared/services/log.service';
import {StatutAvisEnum} from '../../../../models/enums/statut-avis.enum';
import {Annonce} from '../../common/models/annonce';
import {Initial} from './models/Initial';
import {FormfnsServices} from './services/formfns-services/formfns.service';
import {FNSimple} from '../common/models/FNSimple';
import {CommonService} from '../../common/services/common/common.service';
import {FnsimpleService} from '../common/services/fnsimple.service';
import {TypeAvisEnum} from '../../../../models/enums/type-avis.enum';
import {AvisDataTransferService} from '../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class FormfnsExtractorService {
  private LOG: LogService = new LogService(FormfnsExtractorService);

  constructor(private formExtractorService: FormExtractorService, private formfnsServices: FormfnsServices,
              private commonService: CommonService, private fnsimpleService: FnsimpleService,
              private avisDataTransferService: AvisDataTransferService) {
  }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
    const initial = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple;

    if (stepId === 2) {
      initial.communication = this.formfnsServices.communicationService.getCommunication(controls);
    }
    if (stepId === 6) {
      initial.informComplementaire = this.formfnsServices.informComplementaireService.getInformComplementaire(controls);
    }
    if (stepId === 5) {
      if(controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_SepSep_TypeOuiNon_SepAtt_oui') === 'Oui'){
        initial.isMarcheAlloti = true;
      }else if(controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_SepSep_TypeOuiNon_SepAtt_oui') === 'Non'){
        initial.isMarcheAlloti = false;
      }else{
        initial.isMarcheAlloti = null;
      }
      initial.lots = this.formfnsServices.lotsService.getlots(controls, this.formExtractorService);
    }
    if (stepId === 4 || stepId === 5) {
      initial.natureMarche = this.formfnsServices.natureMarcheService.getNatureMarche(
        controls,
        stepId
      );
    }
    if (stepId === 3) {
      initial.procedure = this.formfnsServices.procedureService.getProcedure(controls);
    }
    const fnSimple: FNSimple = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple;
    if (stepId === 1) {
      fnSimple.organisme = this.fnsimpleService.organismeService.getOrganisme(controls);
    }
    fnSimple.initialFromFNSimple = initial;
    fnSimple.attribution = null;
    fnSimple.rectificatifFromFNSimple = null;
    fnSimple.annulationFromFNSimple = null;

    const annonce: Annonce = new Annonce();
    annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = null;
    annonce.ann.mapa = null;
    annonce.ann.fnSimple = fnSimple;
    annonce.ann.formAD = null;
    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
    annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
    const avis: Avis = new Avis();
    //Nettoyer les blocs inexistants
    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.SIMP_IN];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code = TypeAvisEnum.C4_2;
    return avis;
  }
}
